import { render, staticRenderFns } from "./basicAllowanceInfo.vue?vue&type=template&id=25e218f2&scoped=true&"
import script from "./basicAllowanceInfo.vue?vue&type=script&lang=js&"
export * from "./basicAllowanceInfo.vue?vue&type=script&lang=js&"
import style0 from "./basicAllowanceInfo.vue?vue&type=style&index=0&id=25e218f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e218f2",
  null
  
)

export default component.exports